import { HttpContextToken } from '@angular/common/http';

export const IMPERSONATION_CONSTANTS = {
  IMPERSONATION_FLAG_KEY: 'isImpersonating',
  IMPERSONATION_HISTORY_ID: 'impersonationHistoryId',
  IMPERSONATION_HISTORY_END_DATE_PATH: '/ImpersonationEndDateTime',
  IMPERSONATION_SCOPES: 'impersonation sament:v3_entitlements:read_all',
  TARGET_USER_ID_KEY: 'targetUserId'
} as const;

export enum ImpersonationStopReason {
  ApiError = 'apiError',
  Expired = 'expired',
  Logout = 'logout',
  UserInitiated = 'userInitiated',
  ValidationFailed = 'validationFailed'
}

export const SKIP_IMPERSONATION_LOG_METADATA = new HttpContextToken<boolean>(() => false);
